import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortCommentsDesc'
})
export class SortCommentsDescPipe implements PipeTransform {
  transform(comments: any[]): any[] {
    if (!Array.isArray(comments)) return [];
    return [...comments].sort((a, b) => {
      const dateA = new Date(a.created ?? a.createdAt).getTime();
      const dateB = new Date(b.created ?? b.createdAt).getTime();
      return dateB - dateA;
    });
  }
}
